<template>
  <div>
    <TopMenu></TopMenu>
    <div class="divmargin" style="padding:0 20px">
      <el-input placeholder="请输入字典编码" v-model="dict.code" class="txtwidth" clearable size="small"></el-input>
      <el-input placeholder="请输入字典组名称" v-model="dict.name" class="txtwidth" clearable size="small"></el-input>
      <el-button type="primary" @click="getlist" size="small">搜索</el-button>
    </div>
    <div style="padding:0 20px">
      <my-table :tableData="tableData" :columns="dictGroup.tableColumns">
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small">编辑</el-button>
            <el-button @click="operateDict(scope.row.id)" type="text" size="small">删除</el-button>-->
            <el-button @click="operateDict(scope.row.id)" type="text" size="small" v-if="$_has('d-add')">配置字典项</el-button>
          </template>
        </el-table-column>
      </my-table>
    </div>
    <pagination
      style="padding:0 20px"
      :pageSize="pagesize"
      :currentPage="currentPage"
      :pageTotal="pageTotal"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>
    <dialog-panel
      :title="dictBoardTitle"
      :dialogController="dictBoard"
      width="900px"
      @cancel="closeDictBoard"
      :showCancel="true"
      :showConfirm="false"
    >
      <dialog-panel
        :title="dictItemBoardTitle"
        :dialogController="dictitemBoard"
        width="500px"
        @cancel="closeDictItemBoard"
        @confirm="confirmDictBoard"
        :appendToBody="true"
      >
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          size="small"
          @submit.native.prevent="confirmDictBoard"
        >
          <input type="hidden" :value="form.id" />
          <el-form-item label="编码：">
            <el-input v-model="form.code" placeholder="请输入编码"></el-input>
          </el-form-item>
          <el-form-item  label="名称：" class="is-required">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="状态：" class="is-required">
            <select-tmpl
              v-model="form.status"
              :dataOption="statusOptions"
              labels="label"
              values="value"
              placeholder="请选择"
              size="small"
            ></select-tmpl>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </dialog-panel>
      <div class="floatRight">
        <el-button type="primary" size="small" @click="add(groupIdPara)" icon="el-icon-plus">新增字典项</el-button>
      </div>
      <my-table :tableData="dictData" :columns="dictItem.tableColumns">
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </my-table>
      <pagination
        :pageSize="pagesize2"
        :currentPage="currentPage2"
        :pageTotal="pageTotal2"
        @handleCurrentChange="handleCurrentChange2"
      ></pagination>
    </dialog-panel>
  </div>
</template>

<script>
import { StatusOptions } from '@/common/commonDTO' // 公共实体类(状态)
import { DictGroup, Dict } from "../systemDTO";
import { getDictGroup, getCompanyDictPage, updateCompanyDict, addCompanyDict, removeCompanyDictById } from "./dictAPI"
import * as _ from "utils/validate";
import { uuid } from "utils/handle";
import TopMenu from "./../topMenu"
let actionType = 'add'
let groupIdPara = ''
let groupId = ''

export default {
  data () {
    return {
      dictGroup: DictGroup,
      statusOptions: StatusOptions,
      dictBoard: false,
      dictitemBoard: false,
      dictBoardTitle: '配置字典项',
      dictItemBoardTitle: '编辑字典项',
      // isDictCode: true, // 禁用
      dict: {},
      form: {},
      tableData: [],
      dictData: [],
      dictItem: Dict,
      pagesize: 10,
      currentPage: 1,
      pageTotal: 1,
      pagesize2: 10,
      currentPage2: 1,
      pageTotal2: 1,
      groupId: '',
    }
  },
  methods: {
    getlist () {
      let para = {
        code: this.dict.code,
        name: this.dict.name
      }
      getDictGroup(para).then(res => {
        this.tableData = res.data.records,
        this.dictData = res.data.records,
        this.pageTotal = res.data.total,
        this.currentPage =1
      }).catch(err => {
      })
    },
    // 显示字典项
    operateDict (groupId) {
      // console.log('id', groupId,this.pagesize2, this.currentPage2)
      if (groupId) {
        this.groupId = groupId
        this.dictBoard = true
        getCompanyDictPage({ dictGroupId: groupId, current: this.currentPage2, size: this.pagesize2 }).then(res => {
          this.groupIdPara = groupId
          // console.log('数据2', res.data)
          this.dictData = res.data.records
          this.pageTotal2 = res.data.total
        })
        this.currentPage2 =1  // 数据加载后把页面还原成 1
      }
    },
    add (groupId) { // 新建字典项
      this.actionType = 'add'
      this.form = new Dict()
      this.form.id = uuid
      this.form.dictGroupId = groupId
      // isDictCode = false // 启用编码
      // id 
      // 编码
      this.dictItemBoardTitle = `新建字典项`;
      this.dictitemBoard = true;
    },
    edit (obj, groupId) { // 编辑字典项
      this.actionType = 'edit'
      this.dictitemBoard = true
      // isDictCode = true // 禁用编码
      this.dictItemBoardTitle = '编辑字典项'
      this.form = obj
    },
    del (id) { // 删除字典项
      this.$confirm('确定删除该项？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeCompanyDictById(id).then(res => {
          if (res.code === 1000) {
            this.$message.success(`删除成功`);
            this.operateDict(this.groupId)
          }
        })
      }).catch(() => {
        // this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    closeDictBoard () {
      this.dictBoard = false;
    },
    closeDictItemBoard () {
      this.dictitemBoard = false
    },
    confirmDictBoard () {
      let f = {
        ...this.form
      };
      if (_.validNString(f.name)) {
        this.$message.error("名称是必填的");
        return;
      }
      if (_.validNArray(f.status)) {
        this.$message.error("状态是必选的");
        return;
      }
      // console.log('数据', f)
      if (this.actionType === 'edit') {
        updateCompanyDict(f) // 更新
          .then(res => {
            if (res.code === 1000) {
              // this.$message.success(`账号${f.id ? "修改" : "新建"}成功`);
              this.$message.success(`修改成功`);
              this.dictitemBoard = false
              // this.ajaxLoadTable();
            } else {
              // this.$message.warning(`修改失败`);
            }
          })
          .catch(err => {
            this.dictitemBoard = false
          });
      } else if (this.actionType === 'add') {
        addCompanyDict(f).then(res => {
          if (res.code === 1000) {
            this.$message.success(`添加成功`);
            this.dictitemBoard = false
            this.operateDict(this.groupId)
          }
        })
      }
    },
    handleCurrentChange (v) {
      this.currentPage = v
      this.funGetDictGroup()
    },
    handleCurrentChange2 (v) {
      this.currentPage2 = v
      this.operateDict(this.groupId)
    },
    funGetDictGroup () {
      getDictGroup({        current: this.currentPage,
        size: this.pagesize      }).then(res => {
        this.tableData = res.data.records
        this.pageTotal = res.data.total
      }).catch(err => {
      })
    }
  },
  created () {
    this.funGetDictGroup()
  },
  components: {
    TopMenu
  }
}
</script>

<style scoped>
.txtwidth {
  width: 300px;
}
.divmargin {
  margin-top: 5px;
  margin-bottom: 10px;
}
.el-form {
  padding-right: 30px;
}
.floatRight {
  float: right;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/dict/list.vue